import { useEffect } from "react";
import axios from "axios";

const ANALYTICS_URL = "https://microservice.dineapi.com/extapi/kuickanalytics";
const APP_NAME = "Kuick Studio";

// Generate or reuse tab ID
function getOrCreateTabId() {
    try {
        let id = sessionStorage.getItem("uTabID");
        if (!id) {
            id = crypto.randomUUID
                ? crypto.randomUUID()
                : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
            sessionStorage.setItem("uTabID", id);
        }
        return id;
    } catch {
        return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    }
}

// Detect device/platform
function getDevice() {
    const ua = navigator.userAgent || "";
    if (/android/i.test(ua)) return "Android";
    if (/iPad|iPhone|iPod/.test(ua)) return "iOS";
    if (/Windows NT/i.test(ua)) return "Windows";
    if (/Mac OS X/i.test(ua)) return "macOS";
    if (/Linux/i.test(ua)) return "Linux";
    return "Unknown";
}

async function updateReferral(force = false) {
    const uTabID = getOrCreateTabId();
    const refTabID = sessionStorage.getItem("refTabID");

    if (!force && refTabID === uTabID) {
        return { skipped: true };
    }

    const inputData = {
        product: APP_NAME,
        productsource: location.host,
        href: location.href,
        referrer: document.referrer || "",
        tabId: uTabID,
        device: getDevice(),
    };

    try {
        console.log("**************");
        const res = await axios.post(ANALYTICS_URL, { inputData });
        sessionStorage.setItem("refTabID", uTabID);

        return res.data;
    } catch (err) {
        console.log("$$$$$$$$$$$$$");
        sessionStorage.setItem("refTabID", uTabID);
        console.error("Analytics error:", err);
        return null;
    }
}

export function useKuickAnalytics(force = false) {
    useEffect(() => {
        updateReferral(force);
    }, [force]);
}
